import { useEffect, useState } from 'react';
import useAuthentication from '@afosto/auth-react/useAuthentication';

export default () => {
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const [isAuthenticated, isAuthorizing] = useAuthentication();

  useEffect(() => {
    setShowSplashScreen(!isAuthenticated && isAuthorizing);
  }, [isAuthenticated, isAuthorizing]);

  return showSplashScreen;
};
